import React from 'react';
import { Modal } from 'react-bootstrap';
import { MonetizationOnOutlined as MonetizationOnOutlinedIcon } from '@mui/icons-material';
import "./ProductModal.scss";

export default function ProductModal(props) {

    const {rider, title, description, additionalCost} = props.productData;

    return (
        <Modal show={props.productModalShow} className="productModalHighlighted" onHide={() => {props.setProductModalShow(false)}} backdrop={true} size="md" centered scrollable={true}>
            <Modal.Header className="header-content" closeButton>
              <h1>{rider ? rider : title}</h1>
              
                {rider && additionalCost && (
                  <p className="rider-cost">
                    <MonetizationOnOutlinedIcon /> <span className="addtional">Requires Additional Cost</span>
                  </p>
                )}
                {rider && !additionalCost && (
                  <p className="rider-cost">
                    <MonetizationOnOutlinedIcon /> <span className={`noAddtional `}>No Additional Cost</span>
                  </p>
                )}
            </Modal.Header>
            <Modal.Body className="body-content">
              {rider && <p className="note">Riders add benefits to or change the term of an insurance policy.</p>}
              <div className="product-modal-description" dangerouslySetInnerHTML={{ __html: description }}></div>
            </Modal.Body>
        </Modal>
    )
}
